<template>
  <div>
    <div class="p-3 bg-white text-lg flex">
      <v-icon icon="material-symbols:settings" class="text-3xl" />
      <div class="w-full text-center">Pengaturan</div>
    </div>
    <div>
      <div class="py-8 text-center">
        <h2 class="text-2xl font-bold">{{ appTitle }} - ESS App</h2>
        <p class="text-sm text-gray-500">{{appSlogan}}</p>
        <p>
          <span class="text-gray-600">Version :</span>
          {{ version }}
        </p>
        <!-- <div class="mt-2">
          <p class="text-gray-600 text-sm">
            Developed by <a @click="openLink('https://kyuiki.com')" class="text-blue-500">Kyuiki</a> with <a>IT Team</a>
          </p>
        </div> -->
      </div>
    </div>
    <van-cell-group title="Pengaturan Akun">
      <van-cell title="Edit Profil" class="text-gray-500 line-through">
        <template #icon>
          <v-icon icon="material-symbols:person" class="text-2xl mr-3" />
        </template>
      </van-cell>
      <van-cell title="Ganti Password" class="text-gray-500 line-through">
        <template #icon>
          <v-icon icon="material-symbols:key" class="text-2xl mr-3" />
        </template>
      </van-cell>
      <van-cell title="Keluar" class="text-red-500" @click="logout">
        <template #icon>
          <v-icon icon="material-symbols:logout" class="text-2xl mr-3" />
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group title="Term & Conditions">
      <van-cell title="Term Of Service" is-link @click="openLink('https://admin.time-apps.com/tos')">
        <template #icon>
          <v-icon icon="material-symbols:description" class="text-2xl mr-3" />
        </template>
      </van-cell>
      <van-cell title="Privacy Policy" is-link @click="openLink('https://admin.time-apps.com/privacy')">
        <template #icon>
          <v-icon icon="material-symbols:privacy-tip" class="text-2xl mr-3" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import { getQuery } from "@/plugins/queries";
  export default {
    data() {
      return {
        version: getQuery("version") || "1.0.0",
        appTitle: process.env.VUE_APP_TITLE || "App",
        appSlogan: process.env.VUE_APP_SLOGAN || "Slogan Here"
      };
    },
    methods: {
      logout() {
        window.localStorage.removeItem("token");
        try {
          window.NativeStorage.deleteData("token");
        } catch (err) {
          console.error("Failed to save token in NativeStorage", err);
        }
        this.$router.push("/");
      },
      openLink(url) {
        try {
          if (window.NativeLink && window.NativeLink.openUrl) {
            window.NativeLink.openUrl(url);
          } else {
            window.open(url, "_blank");
          }
        } catch (err) {
          console.error("NativeLink not available, falling back to window.open", err);
        }
      }
    }
  };
</script>
